module.exports = __webpack_public_path__ + "static/media/art4.4ee15e83.png";